import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { FacilityProvider } from '../../providers/facility/facility';
import { ToastProvider } from '../../providers/toast/toast';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-all-bookings',
  templateUrl: 'all-bookings.html',
})
export class AllBookingsPage {

  myBookings: any[];
  showData = false;
  locations: any[];


  constructor(public navCtrl: NavController, 
    public navParams: NavParams,
    private translate: TranslateService,
    private facilityProvider: FacilityProvider,
    private toast: ToastProvider) {
      this.facilityProvider.getMyBookings(true).then(val => {
        if(val.status == "success"){
          console.log(val.data)
          this.myBookings = val.data;
          this.showData = true;
          this.addLocationInBooking()
        }
        else{
          this.showData = true;
          this.toast.presentToast("Unable to load");
        }
      }).catch(e => {

      });

      this.facilityProvider.getLocations('').then(val => {
        if(val.status == "success"){
          this.locations = val.data;
        }
      });
  }

  doRefresh(refresher) {
    this.facilityProvider.getMyBookings(true).then(val => {
      if(val.status == "success"){
        this.myBookings = val.data;
      }
      refresher.complete();
    }).catch(e => {
      this.toast.presentToast("Unable to load");
      refresher.complete();
    });
  }
  
  compareDate(fromDate , toDate){
    var fd = new Date(fromDate).getDate();
    var td = new Date(toDate).getDate();
    if(fd == td){
      return true;
    }else{
      return false;
    }
  }

  addLocationInBooking(){
    console.log(this.myBookings,this.locations)
    this.myBookings.forEach((booking)=>{
    this.locations.forEach((location)=>{
     if(booking.location_id == location.id ){
       booking.location = location
           }
    })

  })
  console.log(this.myBookings)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AllBookingsPage');
  }

}




// WEBPACK FOOTER //
// ./src/pages/all-bookings/all-bookings.ts